import { render, staticRenderFns } from "./TestNotesComponent.vue?vue&type=template&id=2bc8fad2"
import script from "./TestNotesComponent.vue?vue&type=script&lang=js"
export * from "./TestNotesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports